export default __webpack_public_path__ + "static/media/logo.f8b2e0c7.svg";